import { Grid, Link, Typography, useMediaQuery } from '@mui/material';

export const Footer = () => {
    /* ******************** Hooks ******************** */
    const matches = useMediaQuery('(max-width: 560px)')
    /* ******************** Variables ******************** */
    const productMenuItems = [
        { label: "How it works", link: undefined },
        { label: "Pricing", link:undefined },
        { label: "Privacy & terms", link:undefined }
    ]
    // const supportMenuItems = [
    //     { label: "Contact us",  link:"https://www.kazikonekt.com/" },
    //     { label: "Privacy & terms", link:"https://www.kazikonekt.com/" }
    // ]
    const companyMenuItems = [
        { label: "About us", link:"https://www.kazikonekt.com/about" },
        { label: "Careers", link:"https://www.kazikonekt.com/careers" },
        { label: "Partnerships", link:"https://www.kazikonekt.com/partnerships" },        
        { label: "Contact",  link:undefined },
    ]
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <Grid 
            container 
            display={"flex"} 
            flexDirection={matches?"column":"row"} 
            bgcolor={'primary.main'}
            paddingX={4} 
            paddingY={5} 
            sx={{ background: 'primary.main'}} 
        >
            <Grid item xs="auto" display={"flex"} justifyContent={matches?"center":"flex-start"} marginBottom={matches?2:0}>
                <img src="/LogoFooter.png" width={142} height={29}/>
            </Grid>
            <Grid
                item
                display={"flex"}
                sx={{
                    ".MuiGrid-root":{
                        margin: "4px 2px 2px 2px",
                        // flex: 1,
                        display: "flex",
                        flexDirection: "column"
                    },
                    ".MuiTypography-root":{
                        color: "#FFF"
                    }
                }}
                flexDirection={"row"}
                marginLeft={matches?0:20}
                justifyContent={matches?"center":"flex-start"}
                gap={matches?2:10}
                xs
            >
                <Grid item xs="auto">
                    <Typography variant="lora-title-small" marginBottom={0.5}>
                        Product
                    </Typography>
                    {
                        productMenuItems.map(item => (
                            <Link key={item.label} href={item.link} paddingBottom={0.5} sx={{textDecoration: !item.link ? 'none' : 'hover'}}>
                                <Typography variant="body-small" color={'#FFF'}>
                                    {item.label}
                                </Typography>
                            </Link>
                        ))
                    }
                </Grid>
                {/* <Grid item xs="auto">
                    <Typography variant="lora-title-small" marginBottom={0.5}>
                        Support
                    </Typography>
                    {
                        supportMenuItems.map(item => (
                            <Link key={item.label} href={item.link} paddingBottom={0.5}>
                                <Typography variant="body-small" color={'#FFF'}>
                                    {item.label}
                                </Typography>
                            </Link>
                        ))
                    }
                </Grid> */}
                <Grid item xs="auto">
                    <Typography variant="lora-title-small" marginBottom={0.5}>
                        Company
                    </Typography>
                    {
                        companyMenuItems.map(item => (
                            <Link key={item.label} href={item.link} paddingBottom={0.5} underline={!item.link ? 'none' : 'hover'} >
                                <Typography variant="body-small" color={'#FFF'}>
                                    {item.label}
                                </Typography>
                            </Link>
                        ))
                    }
                </Grid>
            </Grid>
        </Grid>
    )
}
